import { useMutation } from '@tanstack/react-query'
import { updateShiftRosterHold } from 'api/shift'
import { AxiosError } from 'axios'
import { useAuthContext } from 'components/auth'

export function useUpdateShiftRosterHoldMutation(options: {
  shiftId: number
  onSuccess?: () => void
  onError?: (err: AxiosError) => void
}) {
  const { shiftId, ...otherOptions } = options
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (holdType: 'permanent' | 'temporary') => {
      if (!company?.id) {
        return
      }

      return updateShiftRosterHold(company.id, shiftId, holdType)
    },
    ...otherOptions,
  })
}
